/**
 * @generated SignedSource<<9f00c2868ca7162d02dbda9c51763cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "MapFilterTaxonomySelector_mapTaxonomy"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MapFilterTaxonomyFilterWithChildren_mapTaxonomy",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MapTaxonomy",
      "kind": "LinkedField",
      "name": "children",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "MapTaxonomy",
  "abstractKey": null
};
})();

node.hash = "b30d79280f6a3db434fad4127c1c30bb";

module.exports = node;
